import { exists } from '@/api'

export interface ReferenceImageMaster {
  id: number
  title: string
  fileName: string
  url: string
}

export function ReferenceImageMasterFromJSON(json: any): ReferenceImageMaster {
  return ReferenceImageMasterFromJSONTyped(json)
}

export function ReferenceImageMasterFromJSONTyped(
  json: any
): ReferenceImageMaster {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: exists(json, 'id') ? json.id : 0,
    title: exists(json, 'title') ? json.title : '',
    fileName: exists(json, 'file_name') ? json.file_name : '',
    url: exists(json, 'url') ? json.url : ''
  }
}

export function ReferenceImageMasterToJSON(value: ReferenceImageMaster): any {
  return {
    id: value.id,
    title: value.title,
    file_name: value.fileName,
    url: value.url
  }
}
